import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-form-step3"
export default class extends Controller {
  static targets = ["entryQuestionNotes"];
  declare readonly entryQuestionNotesTarget: HTMLTextAreaElement; // 応募者への質問

  connect(): void {
    this.initScroll();
  }

  initScroll(): void {
    const errorElement = document.querySelector('.txt_error');
    if (errorElement) {
      const elementRect = errorElement.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);
      window.scrollTo({ top: middle, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }

  // テンプレボタンクリック時の処理
  clickTemplateButton() {
    console.log('clickTemplateButton');
    const currentText = this.entryQuestionNotesTarget.value; // 現在のテキスト内容
    const templateText = '【1.志望動機を教えてください】\n\n【2.現在のご職業を教えてください】\n\n【3.現在までのご経歴を教えてください】\n\n【4.入社できる時期を教えてください】';

    if (currentText) {
      this.entryQuestionNotesTarget.value = currentText + '\n\n' + templateText;
    } else {
      this.entryQuestionNotesTarget.value = templateText;
    }
    this.entryQuestionNotesTarget.focus();
  }

  // NOTE: 選考結果の連絡についてのラジオボタンを一旦機能OFFにし、result_contact_type: :other を保存する
  //
  // ラジオボタン「選考結果の連絡について」変更時の処理
  // changeResultContactType(event) {
  //   const resultContactType = event.target.value;
  //   const selectionNote = document.querySelector('.js_selection_note');
  //   if (!selectionNote) return;

  //   // 「その他」を選択した場合、備考欄に必須マークを表示
  //   if (resultContactType === 'other') {
  //     selectionNote.classList.remove('is_any');
  //     selectionNote.classList.add('is_required');
  //   } else {
  //     selectionNote.classList.add('is_any');
  //     selectionNote.classList.remove('is_required');
  //   }
  // }
}
